import { render, staticRenderFns } from "./AccessErrorPage.vue?vue&type=template&id=28465468&scoped=true&"
import script from "./AccessErrorPage.vue?vue&type=script&lang=ts&"
export * from "./AccessErrorPage.vue?vue&type=script&lang=ts&"
import style0 from "./AccessErrorPage.vue?vue&type=style&index=0&id=28465468&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28465468",
  null
  
)

export default component.exports